/**
 * @file Selfie Swap Identity container.
 */

import { connect } from 'react-redux';

import SelfieSwapIdentity from '../../components/selfie-swap/SelfieSwapIdentity';
import { getUploadedPhotoByIdentity } from '../../../../util/photo-upload';
import { openModal, openAlert } from '../../../../actions/modal-actions';

const mapStateToProps = ({ photoUploads }, ownProps) => ({
  uploadedPhoto: getUploadedPhotoByIdentity(
    photoUploads.photos,
    ownProps.identity,
  ),
});

const mapDispatchToProps = {
  openModal,
  openAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfieSwapIdentity);
